import React, { useRef, useState } from 'react';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

/** Purpose: display or rename a canvas node title. Why: node labels should be editable in place while respecting read-only environments. */
export default function EditableNodeTitle({ title = '', onChange, readOnly = false }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(title);
  const finished = useRef(false);
  /** Purpose: Commit a valid title or cancel editing once. Why: Blur and keyboard events can otherwise finish the same edit twice. */
  const finish = (cancel = false) => {
    if (finished.current) return;
    finished.current = true;
    const next = draft.trim();
    if (!cancel && !readOnly && next && next !== title) onChange(next);
    setEditing(false);
  };
  return editing && !readOnly ? (
    <input
      autoFocus
      aria-label="Node name"
      value={draft}
      onFocus={(event) => event.target.select()}
      onChange={(event) => setDraft(event.target.value)}
      onBlur={() => finish()}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
          finish(event.key === 'Escape');
        }
      }}
      className="mt-2 w-full rounded-lg border border-cyan-400 bg-white px-2 py-1 text-lg font-bold text-slate-900 outline-none focus:ring-2 focus:ring-cyan-200 dark:bg-slate-900 dark:text-slate-100"
    />
  ) : (
    <div className="mt-2 flex min-w-0 items-start gap-2">
      <h3 className="min-w-0 break-words text-lg font-bold text-slate-900 dark:text-slate-100">{title || 'Node'}</h3>
      {!readOnly && <button
        type="button"
        aria-label="Rename node"
        title="Rename node"
        onClick={() => { setDraft(title); finished.current = false; setEditing(true); }}
        className="shrink-0 rounded-md p-1 text-slate-500 hover:bg-cyan-50 hover:text-cyan-700 focus-visible:ring-2 focus-visible:ring-cyan-400 dark:hover:bg-slate-800"
      ><EditOutlinedIcon sx={{ fontSize: 17 }} /></button>}
    </div>
  );
}
